import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import './index.scss'

class DealerDetails extends React.Component {
    constructor() {
        super()

        this.state = {
            dealerTimeIntervalId: null,
            dealerTime: '',
        }
    }

    componentDidMount() {
        const dealerTimeIntervalId = this.getDealerTime()

        this.setState({ dealerTimeIntervalId })
    }

    // Get accountId
    getAccountId() {
        const { accountId: savedAccountId } = this.state

        if (savedAccountId) {
            return savedAccountId
        }

        const {
            historicalDialogueLoading: dialogueLoadingRedux,
            historicalDialogue: dialogueRedux,
        } = this.props

        if (dialogueLoadingRedux || !dialogueRedux) {
            return
        }

        if (!dialogueRedux.length) {
            return
        }

        const [firstMessage] = dialogueRedux

        const { AccountId: accountId } = firstMessage

        this.setState({ accountId })

        return accountId
    }

    getDealerTime() {
        const intervalId = setInterval(() => {
            const accountId = this.getAccountId()

            const {
                dealershipDetailsLoading: dealerDetailsLoadingRedux,
                dealershipDetails: dealerDetailsRedux,
            } = this.props

            if (
                !accountId
                || !dealerDetailsRedux
                || dealerDetailsLoadingRedux
            ) {
                return
            }

            let { UtcOffset = '4' } = dealerDetailsRedux

            try {
                UtcOffset = parseInt(UtcOffset, 10)
            } catch (e) {
                UtcOffset = '4'
            }

            const dealerTime = moment()
                .utcOffset(UtcOffset)
                .format('MM/DD/YY HH:mm:ss')

            this.setState({ dealerTime })
        }, 1000)

        return intervalId
    }

    componentWillUnmount() {
        const { dealerTimeIntervalId } = this.state

        if (dealerTimeIntervalId) {
            clearInterval(dealerTimeIntervalId)
        }
    }

    render() {
        const { dealerTime } = this.state

        return (
            <React.Fragment>
                {dealerTime && (
                    <div className='DealerDetails'>
                        <div className='Details__row'>
                            <p>Dealer time</p>
                            <p>{dealerTime}</p>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    const {
        historicalDialogueLoading,
        historicalDialogue,
    } = state.operatorDashboard

    const {
        dealershipDetailsLoading,
        dealershipDetails,
    } = state.operatorDashboardDetails

    return {
        dealershipDetailsLoading,
        dealershipDetails,
        historicalDialogueLoading,
        historicalDialogue,
    }
}

export default connect(mapStateToProps, {})(DealerDetails)
